(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babafuchs-subscription-cancellation"]) return;
  try {
    
  const cancellationRoots = document.querySelectorAll('[data-cancellation-root]');

  cancellationRoots.forEach((root) => {
    const form = root.querySelector('[data-cancellation-form]');

    if (!form) {
      return;
    }

    const startedAt = form.querySelector('[data-cancellation-started-at]');
    const submissionId = form.querySelector('[data-cancellation-submission-id]');
    const declaration = form.querySelector('[data-cancellation-declaration]');
    const reasonField = form.querySelector('[data-cancellation-reason-field]');
    const reason = form.querySelector('[data-cancellation-reason]');
    const dateField = form.querySelector('[data-cancellation-date-field]');
    const desiredDate = form.querySelector('[data-cancellation-date]');
    const statement = form.querySelector('[data-cancellation-statement]');
    const status = form.querySelector('[data-cancellation-status]');
    const submitButton = form.querySelector('button[type="submit"]');
    const receipt = root.querySelector('[data-cancellation-receipt]');
    const mailStatus = receipt.querySelector('[data-cancellation-mail-status]');
    const retryButton = receipt.querySelector('.bf-cancellation__retry');
    const printButton = receipt.querySelector('.bf-cancellation__print');
    let latestPayload = null;

    const createSubmissionId = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      return `bf-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    };

    const selectedType = () => form.querySelector('[data-cancellation-type]:checked')?.value || 'ordinary';
    const selectedDateChoice = () => form.querySelector('[data-cancellation-date-choice]:checked')?.value || 'earliest';

    const syncStatement = () => {
      const extraordinary = selectedType() === 'extraordinary';
      const customDate = selectedDateChoice() === 'desired';
      const statementStart = extraordinary ? root.dataset.statementExtraordinary : root.dataset.statementOrdinary;
      const statementDate = customDate && desiredDate.value
        ? `${root.dataset.dateDesired}: ${desiredDate.value}.`
        : root.dataset.dateEarliest;
      const statementText = `${statementStart} ${statementDate}`;

      reasonField.hidden = !extraordinary;
      reason.disabled = !extraordinary;
      reason.required = extraordinary;
      dateField.hidden = !customDate;
      desiredDate.disabled = !customDate;
      desiredDate.required = customDate;
      statement.textContent = statementText;
      declaration.value = statementText;
    };

    const showStatus = (message, type = 'error') => {
      status.textContent = message;
      status.className = `banner banner--${type}`;
      status.hidden = false;
      status.focus({ preventScroll: true });
    };

    const setBusy = (busy) => {
      submitButton.disabled = busy;
      submitButton.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (busy) {
        showStatus(root.dataset.sending, 'warning');
      }
    };

    const fillReceipt = (result, payload) => {
      const extraordinary = payload.terminationType === 'extraordinary';
      const reasonRow = receipt.querySelector('[data-receipt-reason-row]');
      receipt.querySelector('[data-receipt-reference]').textContent = result.reference;
      receipt.querySelector('[data-receipt-time]').textContent = result.receivedAtLocal || result.receivedAt;
      receipt.querySelector('[data-receipt-name]').textContent = payload.name;
      receipt.querySelector('[data-receipt-email]').textContent = payload.email;
      receipt.querySelector('[data-receipt-postal-code]').textContent = payload.postalCode;
      receipt.querySelector('[data-receipt-contract]').textContent = payload.contractReference;
      receipt.querySelector('[data-receipt-type]').textContent = extraordinary ? root.dataset.typeExtraordinary : root.dataset.typeOrdinary;
      receipt.querySelector('[data-receipt-reason]').textContent = payload.extraordinaryReason || '';
      reasonRow.hidden = !extraordinary;
      receipt.querySelector('[data-receipt-requested-date]').textContent = payload.terminationDateChoice === 'desired'
        ? payload.desiredTerminationDate
        : root.dataset.dateEarliest;
      receipt.querySelector('[data-receipt-effective-date]').textContent = result.effectiveTerminationDate;
      receipt.querySelector('[data-receipt-statement]').textContent = result.declaration || payload.declaration;
      mailStatus.textContent = result.receiptSent ? root.dataset.receivedMailSent : root.dataset.receivedMailFailed;
      retryButton.disabled = result.receiptSent || result.receiptRetryAllowed !== true;
      retryButton.hidden = result.receiptSent || result.receiptRetryAllowed !== true;
    };

    const revealReceipt = (result, payload) => {
      fillReceipt(result, payload);
      form.hidden = true;
      receipt.hidden = false;
      receipt.focus();
    };

    const sendCancellation = async (payload) => {
      setBusy(true);

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const result = await response.json().catch(() => ({}));
        const completeReceipt = result.received === true
          && Boolean(result.reference)
          && Boolean(result.receivedAt)
          && Boolean(result.effectiveTerminationDate);

        if (response.ok && completeReceipt) {
          const update = () => revealReceipt(result, payload);
          if (document.startViewTransition) {
            document.startViewTransition(update);
          } else {
            update();
          }
          return;
        }

        showStatus(result.error || root.dataset.error);
      } catch (error) {
        showStatus(root.dataset.error);
      } finally {
        setBusy(false);
      }
    };

    const now = new Date();
    const localToday = new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
    desiredDate.min = localToday;
    startedAt.value = String(Date.now());
    submissionId.value = createSubmissionId();
    form.querySelectorAll('[data-cancellation-type], [data-cancellation-date-choice]').forEach((control) => {
      control.addEventListener('change', syncStatement);
    });
    desiredDate.addEventListener('change', syncStatement);
    syncStatement();

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.reportValidity()) {
        return;
      }

      latestPayload = Object.fromEntries(new FormData(form).entries());
      sendCancellation(latestPayload);
    });

    retryButton.addEventListener('click', () => {
      if (!latestPayload) {
        return;
      }

      retryButton.disabled = true;
      sendCancellation({ ...latestPayload, retryReceipt: true });
    });

    printButton.addEventListener('click', () => window.print());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babafuchs-withdrawal"]) return;
  try {
    
  const withdrawalRoots = document.querySelectorAll('[data-withdrawal-root]');

  withdrawalRoots.forEach((root) => {
    const form = root.querySelector('[data-withdrawal-form]');
    const startedAt = form.querySelector('[data-withdrawal-started-at]');
    const submissionId = form.querySelector('[data-withdrawal-submission-id]');
    const partialField = form.querySelector('[data-withdrawal-partial-field]');
    const contractPart = form.querySelector('[data-withdrawal-contract-part]');
    const statement = form.querySelector('[data-withdrawal-statement]');
    const partialStatement = form.querySelector('[data-withdrawal-partial-statement]');
    const status = form.querySelector('[data-withdrawal-status]');
    const submitButton = form.querySelector('button[type="submit"]');
    const receipt = root.querySelector('[data-withdrawal-receipt]');
    const mailStatus = receipt.querySelector('[data-withdrawal-mail-status]');
    const retryButton = receipt.querySelector('.bf-withdrawal__retry');
    const printButton = receipt.querySelector('.bf-withdrawal__print');
    let latestPayload = null;
    let inFlight = false;
    let receiptRetryAllowed = false;

    const createSubmissionId = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      return '';
    };

    const selectedScope = () => form.querySelector('[data-withdrawal-scope]:checked')?.value || 'full';

    const syncScope = () => {
      const partial = selectedScope() === 'partial';
      partialField.hidden = !partial;
      contractPart.disabled = !partial;
      contractPart.required = partial;
      statement.hidden = partial;
      partialStatement.hidden = !partial;
    };

    const showStatus = (message, type = 'error') => {
      status.textContent = message;
      status.className = `banner banner--${type}`;
      status.hidden = false;
      status.focus({ preventScroll: true });
    };

    const setBusy = (busy) => {
      inFlight = busy;
      submitButton.disabled = busy;
      retryButton.disabled = busy || !receiptRetryAllowed;
      submitButton.setAttribute('aria-busy', busy ? 'true' : 'false');
      retryButton.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (busy) {
        showStatus(root.dataset.sending, 'warning');
      }
    };

    const fillReceipt = (result, payload) => {
      receipt.querySelector('[data-receipt-reference]').textContent = result.reference || '—';
      receipt.querySelector('[data-receipt-time]').textContent = result.receivedAtLocal || result.receivedAt || '—';
      receipt.querySelector('[data-receipt-name]').textContent = payload.name;
      receipt.querySelector('[data-receipt-email]').textContent = payload.email;
      receipt.querySelector('[data-receipt-contract]').textContent = payload.contractReference;
      receipt.querySelector('[data-receipt-scope]').textContent = payload.scope === 'partial'
        ? `${root.dataset.scopePartial}: ${payload.contractPart}`
        : root.dataset.scopeFull;
      receipt.querySelector('[data-receipt-statement]').textContent = result.declaration || (payload.scope === 'partial'
        ? root.dataset.statementPartial
        : root.dataset.statementFull);
      const mailSent = result.receiptSent === true;
      const manualReview = result.manualReview === true || result.receiptStatus === 'unknown';
      mailStatus.textContent = mailSent
        ? root.dataset.receivedMailSent
        : (manualReview ? root.dataset.receivedMailUnknown : root.dataset.receivedMailFailed);
      receipt.querySelector('[data-withdrawal-receipt-banner]').className = mailSent
        ? 'banner banner--success'
        : 'banner banner--warning';
      const retryAllowed = typeof result.receiptRetryAllowed === 'boolean'
        ? result.receiptRetryAllowed
        : (!mailSent && !manualReview);
      receiptRetryAllowed = retryAllowed;
      retryButton.disabled = !retryAllowed;
      retryButton.hidden = !retryAllowed;
    };

    const revealReceipt = (result, payload) => {
      fillReceipt(result, payload);
      form.hidden = true;
      receipt.hidden = false;
      receipt.focus();
    };

    const sendWithdrawal = async (payload) => {
      if (inFlight) return;
      setBusy(true);

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const result = await response.json().catch(() => ({}));

        if (result.received === true) {
          const update = () => revealReceipt(result, payload);
          if (document.startViewTransition) {
            document.startViewTransition(update);
          } else {
            update();
          }
          return;
        }

        showStatus(result.error || root.dataset.error);
      } catch (error) {
        showStatus(root.dataset.error);
      } finally {
        setBusy(false);
      }
    };

    startedAt.value = String(Date.now());
    submissionId.value = createSubmissionId();
    form.querySelectorAll('[data-withdrawal-scope]').forEach((control) => control.addEventListener('change', syncScope));
    syncScope();

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (inFlight) return;
      if (!form.reportValidity()) {
        return;
      }

      latestPayload = Object.fromEntries(new FormData(form).entries());
      sendWithdrawal(latestPayload);
    });

    retryButton.addEventListener('click', () => {
      if (latestPayload && !inFlight && receiptRetryAllowed) {
        receipt.hidden = true;
        form.hidden = false;
        sendWithdrawal(latestPayload);
      }
    });

    printButton.addEventListener('click', () => window.print());
  });

  } catch(e) { console.error(e); }
})();
})();
